// Auto-incremented on each deploy
const APP_VERSION = '1.2.93';
export default APP_VERSION;
